/**
 * @file StatusBar atom — system status-bar control primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/StatusBar
 */
export { StatusBar } from "@/components/ui/status-bar";
